 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		70: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"pages/content/amlpolicy/pages/content/game-rules/pages/content/intellectual-property/pages/content/l/9f3ea104","2":"pages/cashbox/history/pages/cashbox/payin-error/pages/cashbox/payin-status-ext/pages/cashbox/payin-s/61fd3eac","17":"pages/index/pages/lobby/_section/pages/lobby/_section/_sub-section","19":"pages/cashbox/deposit/pages/cashbox/withdrawal","20":"pages/profile/pages/profile/bonuses/index","32":"header-c","33":"lang-ru.js","34":"lang-ua.js","35":"pages/auth/_social/cb","36":"pages/cashbox/deposit","37":"pages/cashbox/history","38":"pages/cashbox/index","39":"pages/cashbox/payin-error","40":"pages/cashbox/payin-status-ext","41":"pages/cashbox/payin-success","42":"pages/cashbox/payout-error","43":"pages/cashbox/payout-success","44":"pages/cashbox/support","45":"pages/cashbox/withdrawal","46":"pages/content/amlpolicy","47":"pages/content/faq","48":"pages/content/game-rules","49":"pages/content/intellectual-property","50":"pages/content/license","51":"pages/content/partners","52":"pages/content/privacy-policy","53":"pages/content/responsible-gaming","54":"pages/content/rules","55":"pages/error-game","56":"pages/game/_term","57":"pages/index","58":"pages/lobby/_section","59":"pages/lobby/_section/_sub-section","60":"pages/profile","61":"pages/profile/bonuses/index","62":"pages/profile/kycaid","63":"pages/profile/settings/index","64":"pages/profile/support-faq/index","65":"pages/promotions/_term","66":"pages/promotions/index","67":"pages/promotions/welcome-pack/index","68":"pages/registration","69":"pages/verifications/index","72":"vendors/pages/lobby/_section"}[chunkId]||chunkId) + "." + {"0":"d738ae0eed6a1a8c670c","1":"35026888ba125d6cdac2","2":"3f748672b58b05729c65","3":"e7b7ffabc4ebc08ace20","4":"700edc44730cf2efc7c5","5":"06964c7238e466842267","6":"62bc74ea276a65aeeb5c","7":"bc340938aee1af777d1c","8":"b8cc07100bfb380444e9","9":"d472e0e278b582dd2cbb","10":"12e95caf0166f5140cc1","11":"e90cb718aa4b11b38373","12":"961f324d51c2a8cb6eb6","13":"43c8c2983bb10c493029","14":"5074deceac649c87f5f3","15":"c3a9b04297173d0d10a7","16":"27da1fbed7dbfc28ae58","17":"e62de1c49ef589cf45fa","18":"f59751686fd014dd9f77","19":"7d6109fd99e938671052","20":"81be354e18dacf347f78","21":"b1ab760e205beeec244e","22":"c1c75f3311f6fae22f77","23":"591b6c45a15868cc8b25","24":"d08417bd6dfb89660793","25":"55d73a36a219d3457d7f","26":"fe8bf449a1b10ee3e8eb","27":"8dde50c4773e4178552b","28":"bbb7299fdb4863fd2ecf","29":"4f1d0e0e2714c7329332","32":"5c358f2cd636dc14e522","33":"1de3c37f088c4ed3bd65","34":"1fe2bfd690abe6f54038","35":"99f689b0581bfa348114","36":"f4e088d884dbe5d97e17","37":"ab6327cf7d605cfdf811","38":"4d6a412fda1906eb1257","39":"16fcf7a6609ecf0690fd","40":"8296f9630a9e21e3ee33","41":"fc4878065f8424add10d","42":"500a5241c153bea33757","43":"e8ddbda13470a08caf48","44":"d6cae6db13ff2fad7c68","45":"10e02ddf1dfef3b2d8e8","46":"fc9565183c8fbfee6f00","47":"210f687e29075bae9eb6","48":"2a46eb6e7f25462e56f9","49":"75fc7aff78ef69a85072","50":"c8aed60b9a2bf78d1267","51":"47878242954697c2b904","52":"e02d459f33db1534cf08","53":"2d978cf344d7a35497f8","54":"9ce4ad98a6bdd41b4632","55":"164e54eb8a219bcf2364","56":"e4df2b2428511cc4497b","57":"8dc9df49f7c6541a6fda","58":"710b696f8283bfa2fc2a","59":"53dee2a3700ddd31bea8","60":"4aeea3d522cbc69e274b","61":"6c26cb0217c20513c70f","62":"6175af3439dce8b5debe","63":"aaaa428466816ae1e82f","64":"f60549d72636221b7a01","65":"ce789fd46380409b0812","66":"538c531eb5829c5d47b6","67":"52879f63da1b2f346133","68":"847e69dc332bcb753354","69":"90ede82dbd0178baf9f1","72":"266cca528c9e632dc97e","73":"a2a0256e91b4062dc4a0","74":"29be2904fb5024f92bd6","75":"1eb84b2ca1193d1bddfa","76":"e22f4707d7d3c099830f","77":"568612cbb81d66a26159","78":"52405fee775a621f8374","79":"42a84b9b3d2891304254","80":"0fdda5b4412e6d4aa2fe","81":"64ff3d5379a1ea324eba","82":"36e6d06e79fb1845d45b","83":"c2ffa05ed6fec5789a5e","84":"5057f55ea42bb1c8d78d","85":"a8f5c6deb2a2f9ab1590","86":"6e6efc8f433f6e8808d8","87":"ba07ea85c5ee0e6c8701","88":"4914e8efb6b7901a7ab8","89":"ab512d8c69126e155722","90":"ff6e744f3b2d39a836a6","91":"b108992ac6385b9fb41c","92":"3616e3398305c4c7f0d1","93":"bf4bab7ed57d84e2edb1","94":"5e2037df1ad486ca95d8","95":"52e1144ea342767454c8","96":"e05cbfd24418158a466d","97":"a195777bafcc8b867d81","98":"ebf1ff59f2d0ec6d0306","99":"54e5e4e698f83109d016","100":"f21a8c9927106aaee933","101":"362a964f6090fb5ea042","102":"d5c7ca9ca8c8ce5420dd","103":"1e8794994401d698b642","104":"c184304ca3e0c9c2d006","105":"495b4a5a378797322bab","106":"555477de2a87d1c3992c","107":"85a291f19eeffa9a9dcb","108":"81b2743a536db52c4cec","109":"948c0f82164c9915501b","110":"970f86a2dcdb31695ff7","111":"c59dc135aa08691ff5ed","112":"1f12380e1cbd688d7e40","113":"a075ceb11162cdf9e8c9","114":"a1ea2251511dbd9b7038","115":"a8639a84f8a79c487a78","116":"654521160ed2ded32690","117":"ea6d7022f20379548a90","118":"c1ddc11fa279ec02e88c","119":"050bb3f8d6f5df3f2175","120":"d25e880a4704a79a5574","121":"a6ce4061f9455dd27282","122":"dde33a5397dbf7113282","123":"d6df8a464c55b416957f","124":"e577f4c7d7aaec3f5829","125":"cff6a99ca26844e47546","126":"f8834ccbb155303115b7","127":"95f87cc88bdaa86658f7"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/_nuxt/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
